interface GetVendorProductUrlInterface {
  vendor: string;
  locale: string;
  productSlug: string;
}

export function getVendorProductUrl({ vendor, locale, productSlug }: GetVendorProductUrlInterface): string {
  const vendorDomain = vendor?.toLowerCase().replace(/\s+/g, '') || process.env['NEXT_PUBLIC_BRAND_NAME'];
  return `https://${vendorDomain}.com/${locale}${productSlug}`;
}
